/** Check if OPFS is available */
export async function isOPFSAvailable() {
  try {
    if (!navigator.storage || !navigator.storage.getDirectory) {
      return false;
    }
    await navigator.storage.getDirectory();
    return true;
  } catch {
    return false;
  }
}
